import themes from '../config/themes';

/**
 * Detects the tenant/brand based on the current URL hostname
 * @returns {string} 'redwoodseed' or 'initio'
 */
function resolveTenantOverride(tenantOverride) {
  if (tenantOverride === 'redwoodvaluation') return 'redwoodseed';
  return tenantOverride;
}

function applyTenantOverride(tenantOverride) {
  const tenant = resolveTenantOverride(tenantOverride);
  if (tenant && themes[tenant]) {
    localStorage.setItem('tenant', tenant);
    return tenant;
  }
  return null;
}

export function getTenantFromUrl() {
  const urlParams = new URLSearchParams(window.location.search);

  // Preserve tenant across portal redirects (auth -> admin/enterprise)
  if (urlParams.get('portal-switch') === '1') {
    const portalSwitchTenant = applyTenantOverride(urlParams.get('tenant'));
    if (portalSwitchTenant) return portalSwitchTenant;
  }

  // Check for query parameter override (useful for local testing)
  if (process.env.NODE_ENV === 'development') {
    const devTenant = applyTenantOverride(urlParams.get('tenant'));
    if (devTenant) return devTenant;
  }
  const hostname = window.location.hostname.toLowerCase();
  
  if (hostname.includes('redwoodseed') || hostname.includes('redwoodvaluation')) {
    localStorage.setItem('tenant', 'redwoodseed');
    return 'redwoodseed';
  }

  const savedTenant = localStorage.getItem('tenant');
  if (savedTenant && themes[savedTenant]) {
    return savedTenant;
  }

  // Default to initio
  localStorage.setItem('tenant', 'initio');
  return 'initio';
}

/**
 * Gets the theme configuration for a specific tenant
 * @param {string} tenant - The tenant identifier ('initio' or 'redwoodseed')
 * @returns {object} Theme configuration object
 */
export function getThemeConfig(tenant) {
  return themes[tenant] || themes.initio;
}

export function getSupportEmail() {
  const tenant = getTenantFromUrl();
  const theme = getThemeConfig(tenant);
  return theme.supportEmail || 'info@initio.software';
}
export function getBrandName() {
  const tenant = getTenantFromUrl();
  const theme = getThemeConfig(tenant);
  return theme.brandName || 'initio';
}

/**
 * Gets the brand name (capitalized) for the current tenant
 * @returns {string} Brand name capitalized (e.g., 'Initio' or 'Redwood')
 */
export function getBrandNameCapitalized() {
  const tenant = getTenantFromUrl();
  const theme = getThemeConfig(tenant);
  return theme.name || 'Initio';
}

/**
 * Gets the full company name for the current tenant
 * @returns {string} Full company name (e.g., 'Initio Software Inc.' or 'Redwood Valuation, Inc.')
 */
export function getCompanyName() {
  const tenant = getTenantFromUrl();
  const theme = getThemeConfig(tenant);
  return theme.companyName || 'Initio Software Inc.';
}

/**
 * Gets the full company name (uppercase) for the current tenant
 * @returns {string} Full company name uppercase (e.g., 'INITIO SOFTWARE INC.' or 'REDWOOD VALUATION, INC.')
 */
export function getCompanyNameUpper() {
  const tenant = getTenantFromUrl();
  const theme = getThemeConfig(tenant);
  return theme.companyNameUpper || 'INITIO SOFTWARE INC.';
}